// Configuration for running React app independently from ASP.NET Core
const config = {
  // Backend API URL - can be overridden by environment variables
  // When running with ASP.NET Core, leave empty to use same host
  // When running standalone, set to ASP.NET Core backend URL
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL || '',
  
  // API base path
  API_BASE_PATH: process.env.REACT_APP_API_BASE_PATH || '/api',
};

// Helper function to construct full API URLs
export const getApiUrl = (path) => {
  // If no backend URL is configured, return the path as-is (for proxy mode)
  if (!config.BACKEND_URL) {
    return path;
  }
  
  // Remove leading slashes from path
  const sanitizedPath = path.replace(/^\/+/, '');
  
  // Ensure backend URL doesn't end with a slash
  const baseUrl = config.BACKEND_URL.replace(/\/+$/, '');
  
  return `${baseUrl}/${sanitizedPath}`;
};



export default config;